<template>
  <div class="houst-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-between">
        <div class="flex-sub margin-right">
          <div class="flex align-center justify-between margin-bottom-xs">
            <div class="flex align-center margin-right-sm basis-smf">
              <span>房屋性质：</span>
              <el-select v-model="housingNature" placeholder="请选择" class="flex-sub">
                <el-option
                    v-for="item in housingNatureList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="flex align-center margin-right-sm basis-smf">
              <span>居住情况：</span>
              <el-select v-model="liveSituation" placeholder="请选择" class="flex-sub">
                <el-option
                    v-for="item in liveSituationList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <fiveLevel @upFive="upFive"/>
        </div>
        <el-button type="primary" @click="hanldSearch">搜索</el-button>
      </div>

      <div class="flex align-center justify-between margin-tb-sm">
        <div>
          共{{total}}条数据
        </div>
        <div>
          <el-button
              v-if="[3,5].includes(user.power)"
              size="small"
              type="warning"
              @click="exportRroomList"
          >导出房屋数据
          </el-button>
        </div>
      </div>

      <el-table
          :data="houstList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          border
          style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <el-table-column label="社区" prop="xiangmu_name"></el-table-column>
        <el-table-column label="小区" prop="xiaoqu_name"></el-table-column>
        <el-table-column label="楼门户" >
          <template slot-scope="scope">
            <div>
              {{ scope.row.building_name }}-{{scope.row.element_name}}-{{scope.row.room_name}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="房屋面积(平米)" prop="mianji"></el-table-column>
        <el-table-column label="房屋性质">
          <template slot-scope="scope">
            <div>
              {{ scope.row.xingzhi | xingzhi }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="户主姓名" prop="huzu_name"></el-table-column>
        <el-table-column label="手机号" prop="huzu_phone"></el-table-column>
        <el-table-column label="居住情况">
          <template slot-scope="scope">
            <div>
              {{ scope.row.juzhu_qingkuang | juzhu_qingkuang }}
            </div>
          </template>
        </el-table-column>
<!--        <el-table-column label="综改调查">-->
<!--          <template slot-scope="scope">-->
<!--            <div>-->
<!--              {{ scope.row.zonggai | zonggai }}-->
<!--            </div>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="物业合同">-->
<!--          <template slot-scope="scope">-->
<!--            <div>-->
<!--              {{ scope.row.wuyehetong | wuyehetong}}-->
<!--            </div>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="负责人" prop="yuangong_name"></el-table-column>


        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                  size="small"
                  type="primary"
                  @click="editItem(scope.row)"
              >编辑
              </el-button>
                <el-button
                    size="small"
                    type="primary"
                    @click="setShebeiItem(scope.row)"
                >设备管理
                </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          v-if="houstList.length > 0"
          class="page-all"
          background
          @current-change="getResidentList"
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
    </div>
    <houstDialog
        :setId="setId"
        :setItem="setItem"
        :houstDialog="houstDialog"
        @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>

import {optionList, filesCN, housingNature, liveSituation, reform, contract} from "@/utils/utils";
import houstDialog from "@/views/pages/dialog/houstDialog";
import fiveLevel from '@/components/five-level'
import {roomList} from "@/api/houst";
import {exportRroomList} from "@/api/exportExcel";

export default {
  name: "housing-data",
  data() {
    return {
      housingNatureList: optionList(true, housingNature),
      liveSituationList: optionList(true, liveSituation),
      housingNature: 0,
      liveSituation: 0,
      project: 0,
      community: 0,
      building: 0,
      unit: 0,
      room: 0,
      page: 1,
      limit: 10,
      total: 0,
      houstList: [],
      setId: 0,
      setItem: {},
      houstDialog: false,
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "房屋数据", false);
    this.getResidentList()
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {
    fiveLevel,
    houstDialog
  },
  methods: {
    //  房屋信息导出
    async exportRroomList(){
      let _state = await exportRroomList(
          this.project,
          this.community,
          this.building,
          this.unit,
          this.room,
          this.housingNature,
          this.liveSituation
      )
      let blob = _state.data
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.setAttribute('download', '房屋数据.csv');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },
      //  设备管理
      setShebeiItem(obj) {
          this.$router.push(`/home/housing-dev/${obj.id}`)
      },
    //  房屋信息编辑后回调
    cancelDialog(val) {
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.houstDialog = false;
        this.getResidentList();
      } else {
        this.setId = 0;
        this.setItem = {};
        this.houstDialog = false;
      }
    },
    //  编辑
    editItem(obj){
      this.setItem = obj;
      this.setId = obj.id;
      this.houstDialog = true;
    },
    //  搜索
    hanldSearch() {
      this.page = 1
      this.getResidentList()
    },
    //  获取房屋列表
    async getResidentList() {
      let _data = await roomList(
          this.project,
          this.community,
          this.building,
          this.unit,
          this.room,
          this.housingNature,
          this.liveSituation,
          this.page,
          this.limit
      )
      this.houstList = _data.data
      this.total = _data.total_number
    },
    //  同步更新五级联动
    upFive(val) {
      this.project = val.project
      this.community = val.community
      this.building = val.building
      this.unit = val.unit
      this.room = val.room
    }
  },
  filters: {
    juzhu_qingkuang(val){
      return filesCN(val,liveSituation)
    },
    zonggai(val){
      return filesCN(val,reform)
    },
    wuyehetong(val){
      return filesCN(val,contract)
    },
    xingzhi(val){
      return filesCN(val,housingNature)
    },
  },
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
